import { NextSeo } from 'next-seo';
import PropTypes from 'prop-types';

import AssembleLayout from '@/src/layouts/AssembleLayout';
import MainLayout from '@/src/layouts/MainLayout';
import { blogPostsGet, blogCategoriesGet } from '@/src/lib/prismic/queries';
import { urlHostResolver } from '@/src/lib/utils';
import BlogIndex from '@/src/views/blog/BlogIndex';

export default function BlogIndexPage({ doc, preview }) {
  return (
    <AssembleLayout Layout={MainLayout} Component={BlogIndex} doc={doc} preview={preview}>
      <NextSeo
        title="Blog"
        description="Acompanhe artigos escritos especialmente para escolas, parceiros, famílias e qualquer pessoa interessada no futuro da educação."
        openGraph={{
          title: 'Blog',
          url: urlHostResolver(`/blog`),
          images: [
            {
              url: urlHostResolver(`/images/illustrations/blog.png`),
              width: 1125,
              height: 571,
              alt: 'Blog',
            },
          ],
        }}
      />
    </AssembleLayout>
  );
}

BlogIndexPage.propTypes = {
  doc: PropTypes.object,
  preview: PropTypes.bool,
};

export async function getStaticProps(context) {
  const { preview = false, previewData = {} } = context;
  const { ref } = previewData;
  const graphQuery = `{
    blog-post {
      cover
      title
      description
      date
      author {
        name
        avatar
      }
    }
  }`;

  const posts = await blogPostsGet({ graphQuery }, { ref });
  const categories = await blogCategoriesGet();

  return {
    props: { doc: { posts, categories }, preview },
    revalidate: 180,
  };
}
